import CompanyAvailabilityRegularCell from './CompanyAvailabilityRegularCell';

export default CompanyAvailabilityRegularCell;
